const prefix = 'PROJECT';

export const GET_SINGLE_PROJECT = Symbol(`${prefix}/GET_SINGLE_PROJECT`);
export const GET_SINGLE_PROJECT_SUCCESS = Symbol(`${prefix}/GET_SINGLE_PROJECT_SUCCESS`);
export const GET_SINGLE_PROJECT_FAIL = Symbol(`${prefix}/GET_SINGLE_PROJECT_FAIL`);
